export const config = window.addiesaas.config

export default {
  created() {
    this.config = config
  },
  mounted() {

  },
}

